import { Box } from '@mui/material'
import style from './CalendarModal.module.css'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Header } from '../../components/header/Header'
import close from '../../assets/articles/delete.svg'
import { ExternAppointment } from 'modules/calendar/models/ExternAppointment'
import dayjs from 'dayjs'
import { ExternAppointmentStatus } from 'modules/calendar/enums/ExternAppointmentStatus'

type CalendarModalProps = {
  handleClose: () => void
  handlerEventClick: (event: ExternAppointment) => void
  events: ExternAppointment[]
  date: Date | string
  startHour: string
  endHour: string
}

type WeekEvent = {
  event: ExternAppointment
}

export const CalendarModal = (props: CalendarModalProps) => {
  const { t } = useTranslation()
  const [filteredEvents, setFilteredEvents] = useState<ExternAppointment[]>([])

  const filterEventsByDayAndHour = (
    events: ExternAppointment[],
    date: Date | string,
    startHour: string,
    endHour: string
  ): ExternAppointment[] => {
    const startHourInt = parseInt(startHour.split(':')[0], 10)
    const endHourInt = parseInt(endHour.split(':')[0], 10)

    return events.filter((event) => {
      const eventStart = dayjs(event.dateFrom).toDate()
      const eventEnd = event.dateTo
      const isSameDay = eventStart.getDate() === Number(date.toString())
      const startsBeforeEndHour = eventStart.getHours() <= endHourInt
      const endsAfterStartHour =
        eventEnd.getHours() >= startHourInt || dayjs(eventEnd).isAfter(eventStart, 'day')

      return isSameDay && startsBeforeEndHour && endsAfterStartHour
    })
  }

  const handlerClick = (event: ExternAppointment) => {
    props.handlerEventClick(event)
    props.handleClose()
  }

  const getStatusColor = (status: number) => {
    switch (status) {
      case ExternAppointmentStatus.Pending:
        return '#F0C982'
      case ExternAppointmentStatus.Accepted: // Confirmed (Confirmada)
        return '#C1E4C2'
      case ExternAppointmentStatus.Completed: // In progress (En progreso)
        return '#96C5EA'
      case ExternAppointmentStatus.Finalized: // Completed (Completada)
        return '#B47FBD'
      case ExternAppointmentStatus.Canceled: // Cancelled (Cancelada)
        return '#F19189'
      default:
        return '#cfd8dc'
    }
  }

  function DiaryEvent2(weekEvent: WeekEvent): JSX.Element {
    let duration
    if (
      dayjs(weekEvent.event.dateTo).format('DD').toString() ===
      dayjs(weekEvent.event.dateFrom).format('DD').toString()
    ) {
      duration =
        Number(dayjs(weekEvent.event.dateTo).format('HH')) -
        Number(dayjs(weekEvent.event.dateFrom).format('HH'))
    }

    return (
      <>
        {weekEvent.event.dateFrom === weekEvent.event.dateTo ? (
          <Box
            className={style.eventNotSameDay}
            onClick={() => handlerClick(weekEvent.event)}
            style={{
              backgroundColor: getStatusColor(weekEvent.event.status),
            }}
          >
            <h3 className={style.eventTitleNotSameDay}>
              {dayjs.utc(weekEvent.event.dateFrom).format('HH:mm') +
                ' ' +
                weekEvent.event.patient.firstName}
            </h3>
          </Box>
        ) : (
          <Box
            className={style.event}
            onClick={() => handlerClick(weekEvent.event)}
            style={{
              ['--duration-height' as any]: duration,
              ['--col' as any]: getStatusColor(weekEvent.event.status),
              backgroundColor: getStatusColor(weekEvent.event.status),
            }}
          >
            <h3 className={style.eventTitle}>
              {`${dayjs(weekEvent.event.dateFrom).format('HH:mm')} - ${dayjs(
                weekEvent.event.dateTo
              ).format('HH:mm')} ${weekEvent.event.patient.firstName} ${
                weekEvent.event.patient.lastName
              }`}
            </h3>
          </Box>
        )}
      </>
    )
  }

  useEffect(() => {
    const filtered = filterEventsByDayAndHour(
      props.events,
      props.date,
      props.startHour,
      props.endHour
    )
    console.log(props.events)
    console.log(props.startHour)
    console.log(props.endHour)
    console.log(filtered)
    setFilteredEvents(filtered)
  }, [props.events, props.date, props.startHour, props.endHour])

  return (
    <>
      <Box className={style.modalView}>
        <Header
          label={
            t('eventsForDay') +
            ' ' +
            props.date.toString() +
            ' ' +
            props.startHour +
            '-' +
            props.endHour
          }
          icon={close}
          onClick={props.handleClose}
        />

        <Box className={style.eventsContainer}>
          {filteredEvents.length > 0 ? (
            filteredEvents.map((event) => (
              <Box key={event.id} className={style.eventItem}>
                <DiaryEvent2 event={event} key={event.id} />
              </Box>
            ))
          ) : (
            <Box className={style.noEvents}>
              <p>{t('noEventsDiary')}</p>
            </Box>
          )}
        </Box>
      </Box>
    </>
  )
}
